import { extends as _extends, objectSpread2 as _objectSpread2 } from '../../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React, { forwardRef, useContext } from 'react';
import { FieldErrorContext } from 'react-aria-components';
import Text from '../../../text/text.esm.js';
import { useRenderProps } from '../../../utils/index.esm.js';

var FieldErrorInner = /*#__PURE__*/forwardRef(function FieldErrorInner(props, ref) {
  var validation = useContext(FieldErrorContext);
  var renderProps = useRenderProps(_objectSpread2(_objectSpread2({}, props), {}, {
    defaultClassName: 'react-aria-FieldError',
    defaultChildren: validation.validationErrors.length === 0 ? undefined : validation.validationErrors.join(' '),
    values: validation
  }));
  if (renderProps.children == null) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Text, _extends({
    slot: "errorMessage"
  }, renderProps, {
    ref: ref,
    ellipsis: "1"
  }));
});
function FieldError(props, ref) {
  var validation = useContext(FieldErrorContext);
  if (!(validation !== null && validation !== void 0 && validation.isInvalid)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(FieldErrorInner, _extends({}, props, {
    ref: ref
  }));
}

/**
 * A FieldError displays validation errors for a form field.
 */
var _FieldError = /*#__PURE__*/forwardRef(FieldError);

export { _FieldError as default };
//# sourceMappingURL=field-error.esm.js.map
